/**
 * Utility to enable/disable the scroll.
 * It sets the document body overflow property to hidden, which
 * is enough for most of the browsers. However, this is not the case on
 * iOS, where position: fixed do the trick, sacrificing the scroll position.
 * The utility applies some tricks with the css property `top` to "maintain" the
 * scroll position. If you need to get the values of the scrollPosition when the
 * scroll is blocked, use the method `getPosition()` to get the scroll value
 * before the block
 */

let scrollPosition = null;
let scrollBlocked = false;
const lockCssClass = 'lock-scroll';

const enable = () => {
  var bodyEle = document.querySelector('body');
  if (!bodyEle.classList.contains(lockCssClass)) {
    scrollPosition = window.pageYOffset;
    scrollBlocked = true;
    document.body.style.top = `-${scrollPosition}px`;
    document.body.classList.add(lockCssClass);
  }
};

const disable = () => {
  scrollBlocked = false;
  document.body.classList.remove(lockCssClass);
  window.scrollTo(0, scrollPosition);
};

const isBlocked = () => scrollBlocked;

const getPosition = () => scrollPosition;

const getOffsetY = () => (isBlocked() ? getPosition() : window.pageYOffset);

const scrollBlocker = {
  enable,
  disable,
  isBlocked,
  getPosition,
  getOffsetY,
};

export default scrollBlocker;
